// extracted by mini-css-extract-plugin
export default {"headerBtn":"styles_headerBtn__8jGla","disabled":"styles_disabled__1nviK","YoelloButton":"styles_YoelloButton__HGApL","Clickable":"styles_Clickable__T9dmp"};